/**
 * apiClient.js
 * Central fetch wrapper for RBAC backend calls.
 * Automatically refreshes expired access tokens and retries once.
 * If refresh fails → clears session and reloads to /login.
 */

import { getAccessToken } from './auth';
import { handleUnauthorized } from './tokenRefresh';

/**
 * rbacFetch — drop-in fetch replacement for RBAC API calls
 * Attaches Bearer token and handles 401 with silent refresh + retry
 */
export async function rbacFetch(url, options = {}) {
  const makeRequest = (accessToken) => fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...options.headers,
    },
  });

  let response = await makeRequest(getAccessToken());

  if (response.status === 401) {
    const newToken = await handleUnauthorized(); // shared — won't double-refresh
    response = await makeRequest(newToken);
  }

  return response;
}
